import objectPath from "object-path";
import config from "@/common/config/layout.config.json";
import adminConfig from "@/common/config/menu.admin.config.json";
import merchantAdminConfig from "@/common/config/menu.merchantadmin.config.json";
import merchantUserConfig from "@/common/config/menu.merchantuser.config.json";
import { debug } from "../services/LoggerService";

// action types
export const SET_LAYOUT_CONFIG = "setLayoutConfig";
export const OVERRIDE_LAYOUT_CONFIG = "overrideLayoutConfig";

// mutation types

export default {
  state: {
    config: config,
    adminConfig,
    merchantAdminConfig,
    merchantUserConfig
  },
  getters: {
    /**
     * Get config from layout config
     * @param state
     * @returns {function(path, defaultValue): *}
     */
    layoutConfig: state => (path, defaultValue) => {
      return objectPath.get(state.config, path, defaultValue);
    },
    additionalConfig: (state, getters) => (path, defaultValue) => {
      try {
        if (getters.isAdmin) {
          return objectPath.get(state.adminConfig, path, defaultValue);
        }

        if (getters.isMerchantAdmin) {
          return objectPath.get(state.merchantAdminConfig, path, defaultValue);
        }

        if (getters.isMerchantUser) {
          return objectPath.get(state.merchantUserConfig, path, defaultValue);
        }
      } catch (e) {
        debug(e);
      }
      return getters.layoutConfig(path, defaultValue);
    },
    isAsideEnabled(state, getters) {
      const asideDisplayPath = "aside.self.display";
      return (
        !!getters.layoutConfig(asideDisplayPath) &&
        !!getters.additionalConfig(asideDisplayPath)
      );
    }
  },
  actions: {
    [SET_LAYOUT_CONFIG](state, payload) {
      state.commit(SET_LAYOUT_CONFIG, payload);
    },
    [OVERRIDE_LAYOUT_CONFIG](state) {
      state.commit(OVERRIDE_LAYOUT_CONFIG);
    }
  },
  mutations: {
    [SET_LAYOUT_CONFIG](state, payload) {
      state.config = payload;
    },
    [OVERRIDE_LAYOUT_CONFIG](state) {
      state.config = Object.assign(
        {},
        state.config,
        JSON.parse(localStorage.getItem("config"))
      );
    }
  }
};
